import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ClientWorkspaceRoutingModule } from './client-workspace-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';

import { MatIconModule } from '@angular/material/icon';
import { UiScrollModule } from 'ngx-ui-scroll';

import { CsrAccountComponent } from './components/csr-account/csr-account.component';
import { ClientDashboardTilesComponent } from './components/client-dashboard-tiles/client-dashboard-tiles.component';
import { ClientStatsClickthroughsComponent } from './components/client-stats-clickthroughs/client-stats-clickthroughs.component';
import { ClientStatsEnrollmentsComponent } from './components/client-stats-enrollments/client-stats-enrollments.component';
import { ClientStatsPrefChangesComponent } from './components/client-stats-pref-changes/client-stats-pref-changes.component';
import { ClientStatsIncompleteEnrollmentsComponent } from './components/client-stats-incomplete-enrollments/client-stats-incomplete-enrollments.component';
import { RtpnTransactionsComponent } from './components/rtpn-transactions/rtpn-transactions.component';
import { RtpnSimulatorComponent } from './components/rtpn-simulator/rtpn-simulator.component';

@NgModule({
  declarations: [
    CsrAccountComponent,
    ClientDashboardTilesComponent,
    ClientStatsClickthroughsComponent,
    ClientStatsEnrollmentsComponent,
    ClientStatsPrefChangesComponent,
    ClientStatsIncompleteEnrollmentsComponent,
    RtpnTransactionsComponent,
    RtpnSimulatorComponent
  ],
  imports: [
    SharedModule,
    ClientWorkspaceRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    SelectModule,
    CardModule,
    MessageModule,
    CheckboxModule,
    PanelModule,
    TooltipModule,
    TableModule,
    DatePickerModule,
    ChartModule,
    InputTextModule,
    TabsModule,
    ConfirmDialogModule,
    DialogModule,
    MatIconModule,
    UiScrollModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ClientWorkspaceModule { }
